export default __webpack_public_path__ + "static/media/floor4.8ecc0d9f.svg";